// extracted by mini-css-extract-plugin
export var hidden = "_4y-1";
export var leftPanel = "_4y-2";
export var readonlyInspector = "_4y-3";
export var rightPanel = "_4y-0";